import { NgModule, ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const appRoutes: Routes = [

];

@NgModule({
	imports: [
		RouterModule.forRoot(
			appRoutes,
			{
				useHash: true,
                onSameUrlNavigation: 'reload'
			})
		],
	providers: [],
	exports: [
		RouterModule
	]
})
export class AppRoutingModule {}
